<template>
  <BreadCrumb PageTitle="Gestion des annonces" />
  <AdsSettings />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AdsSettings from "../../components/Generals/AdsSettings.vue";

export default defineComponent({
  name: "AdsSettingsPage",
  components: {
    BreadCrumb,
    AdsSettings,
  },
});
</script>